"use client";

import ReasonContent from "./ReasonContent";
import ReasonLogo from "./ReasonLogo";
import styles from "./ReasonWhy.module.scss";

export default function ReasonWhy() {
  return (
    <section
      className={`${styles.reasonWrapper} reason-wrapper-trigger`}
    >
      <div className={styles.contentLayer}>
        <ReasonContent />

        <ReasonLogo />
      </div>
    </section>
  );
}